/**
 * Adds authentication token to avatar URL if needed.
 * Returns null if no avatarUrl provided.
 *
 * @param {string|null|undefined} avatarUrl
 * @returns {string|null}
 */
export function getAuthenticatedAvatarUrl(avatarUrl) {
  if (!avatarUrl || typeof avatarUrl !== 'string') return null;
  if (avatarUrl.startsWith('data:') || avatarUrl.startsWith('blob:')) {
    return avatarUrl;
  }
  let fullUrl = avatarUrl;
  if (fullUrl.startsWith('/api') && process.env.REACT_APP_BACKEND_URL) {
    const backendOrigin = process.env.REACT_APP_BACKEND_URL.replace(/\/api\/?$/, '');
    fullUrl = `${backendOrigin}${fullUrl}`;
  }
  if (fullUrl.includes('bearer=')) {
    return fullUrl;
  }

  const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
  if (!token) {
    return fullUrl;
  }
  const separator = fullUrl.includes('?') ? '&' : '?';
  return `${fullUrl}${separator}bearer=${encodeURIComponent(token)}`;
}
